import { useCallback, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';

import { useUserActions } from '@/entities/user/model/user.store';
import { useXPWallet } from '@/entities/user/model/wallet.store';

import { ROUTE_PATHS } from '@/shared/config/router/types';
import { BoosterType } from '@/shared/ui/booster/booster.types';
import { useStickyBannerActions } from '@/shared/ui/sticky-banner';

import { BoosterStickyBanner } from '../ui';

export const XP_BOOSTER_BANNER_KEY = BoosterType.BOOSTER_XP;

export const useXPBoostStickyBanner = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const XPWallet = useXPWallet();

  const { fetchUser } = useUserActions();

  const boosterValue = XPWallet?.activeBooster?.value ?? 0;
  const activeTo = XPWallet?.activeBooster?.activeTo;
  const selectionKey = XPWallet?.activeBooster?.selectionKey;

  const { open: openBanner, close, updateProps } = useStickyBannerActions();

  const handleEndTimer = useCallback(() => {
    close(XP_BOOSTER_BANNER_KEY);

    // Wallet may not be updated via WS
    fetchUser();
  }, [close, fetchUser]);

  let categoryPath = selectionKey ? `${ROUTE_PATHS.CATEGORY}/${selectionKey}` : undefined;

  if (categoryPath === pathname) {
    categoryPath = undefined;
  }

  useEffect(() => {
    updateProps(XP_BOOSTER_BANNER_KEY, {
      onClick: categoryPath
        ? () =>
            navigate(categoryPath, {
              state: { source: 'xp_booster_sticky_banner' },
            })
        : undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryPath]);

  const open = useCallback(() => {
    return openBanner(XP_BOOSTER_BANNER_KEY, {
      onClick: categoryPath
        ? () =>
            navigate(categoryPath, {
              state: { source: 'xp_booster_sticky_banner' },
            })
        : undefined,
      content: (
        <BoosterStickyBanner
          boosted={boosterValue}
          expireTime={activeTo}
          onEnd={handleEndTimer}
          boosterType={BoosterType.BOOSTER_XP}
        />
      ),
    });
  }, [openBanner, categoryPath, boosterValue, activeTo, handleEndTimer, navigate]);

  useEffect(() => {
    if (boosterValue && activeTo) {
      open();
      return;
    }

    if (!boosterValue || !activeTo) {
      close(XP_BOOSTER_BANNER_KEY);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTo, boosterValue]);

  return { open, close };
};
